import { ActivityType, ServiceCode } from '@common/enums';

export function doesPayoutDependOnProfession(
    serviceCode: ServiceCode | null | undefined,
    activityType: ActivityType | null | undefined
): boolean {
    if (!serviceCode || !activityType) {
        return false;
    }

    return (
        activityType === ActivityType.consultation &&
        [ServiceCode.GGZCt, ServiceCode.GGZCg, ServiceCode.GGZCf2f, ServiceCode.GGZCmdo].includes(serviceCode)
    );
}
